var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CustomElement, P, PacemEventTarget, Watch, PropertyConverters, Utils } from './_default-imports';
import { CustomElementUtils } from '../../utils-customelement';
//namespace Pacem.Components {
const REMOVE_VALUE = 'false';
const EMPTY_VALUE = 'true';
let PacemLayoutProxyElement = class PacemLayoutProxyElement extends PacemEventTarget {
    #shell;
    connectedCallback() {
        super.connectedCallback();
        this.#shell = CustomElementUtils.findAncestorShell(this);
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        this._update();
    }
    disconnectedCallback() {
        const attr = this.attr;
        if (!Utils.isNullOrEmpty(attr)) {
            this._update(attr, REMOVE_VALUE, false);
        }
        super.disconnectedCallback();
    }
    _update(key = this.attr, value = this.value?.toString(), disabled = this.disabled) {
        if (Utils.isNullOrEmpty(key) || disabled) {
            // No key means do nothing
            return;
        }
        const layout = this.#shell;
        if (!Utils.isNull(layout)) {
            if (Utils.isNullOrEmpty(value) || value === REMOVE_VALUE) {
                layout.removeAttribute(key);
            }
            else {
                layout.setAttribute(key, value === EMPTY_VALUE ? '' : value);
            }
        }
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemLayoutProxyElement.prototype, "attr", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemLayoutProxyElement.prototype, "value", void 0);
PacemLayoutProxyElement = __decorate([
    CustomElement({
        tagName: P + '-layout-proxy'
    })
], PacemLayoutProxyElement);
export { PacemLayoutProxyElement };
//}
